import useLogout from '@/services/api/auth/useLogout.js'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function LogoutPage() {
  const navigate = useNavigate()

  const { logout } = useLogout()

  useEffect(() => {
    const performLogout = async () => {
      await logout()
      navigate('/login')
    }
    performLogout()
  }, [logout, navigate])

  return <div>Logging out...</div>
}
